import { Drawer, styled } from "@mui/material";

export const CustomDrawer = styled(Drawer)(({ theme }) => ({
  width: "25%",

  "& .MuiDrawer-paper": {
    bottom: "0px !important",
    width: "40%",
    borderRadius: "6px 0px",
    padding: 10,
    height: "100% !important",
  },
}));

export const AssetViewDrawer = styled(Drawer)(({ theme }) => ({
  width: "25%",
  zIndex: 1203,
  "& .MuiDrawer-paper": {
    bottom: "0px !important",
    width: "40%",
    borderRadius: "6px 0px",
    padding: 10,
    height: "100% !important",
  },
}));

export const JunctionDetailsDrawer = styled(Drawer)(({ theme }) => ({
  width: "25%",
  zIndex: 1200,
  "& .MuiDrawer-paper": {
    bottom: "0px !important",
    width: "40%",
    borderRadius: "6px 0px",
    padding: 10,
    height: "100% !important",
  },
}));

export const CustomDrawerInMaps = styled(Drawer)(({ theme }) => ({
  width: "25%",
  "& .MuiDrawer-paper": {
    bottom: "0px !important",
    top: "auto !important",
    width: "25%",
    borderRadius: "6px 0px",
    padding: 10,
    height: "40% !important",
  },
}));


export const CustomDrawerInMobile = styled(Drawer)(({ theme }) => ({
  width: "25%",

  "& .MuiDrawer-paper": {
    bottom: "0px !important",
    width: "100%",
    borderRadius: "6px 0px",
    padding: 10,
    height: "calc(100% - 30px) !important",
    background:"#1C1C1D !important",
    marginTop:"30px !important",
    
  
  },
}));